import { isPasskeySupported as e, openPasskeyCeremony as t } from "@akedly/shield";
//#region src/passkeys/web/openPasskeyCeremony.ts
var n = 12e4, r = () => {
	if (typeof window > "u") return null;
	try {
		return window.open("about:blank", "akedly_passkey", "width=480,height=680");
	} catch {
		return null;
	}
}, i = (e, r) => t(e, {
	popup: r,
	timeoutMs: n
});
//#endregion
export { n as PASSKEY_CEREMONY_TIMEOUT_MS, e as isPasskeySupported, r as openPasskeyPopup, i as runPasskeyCeremony };
